<template>
  <div>
    <Breadcrumbs
      title="Delivery Schedule History"
      :breadcrumbs="[
        { label: 'Delivery Schedule History', path: '' },
        {
          label: 'Dispatch Schedule History',
          path: '/delivery-schedule-history',
        },
      ]"
    />

    <div class="container-fluid">
      <div class="row project-cards">
        <DeliveryScheduleHistoryData />
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryScheduleHistoryData from "@/pages/stock/delivery_schedule_history/delivery_schedule_history_data.vue";

export default {
  name: "DeliveryScheduleHistory",

  components: {
    DeliveryScheduleHistoryData,
  },
};
</script>